import {Component, OnInit, Inject, ViewEncapsulation} from '@angular/core';
import { Countries } from 'src/app/models/countries';
import { TranslateService } from '@ngx-translate/core';
import { AddFarm } from 'src/app/models/addFarm';
import { HelperService } from 'src/app/helper.service';
import { MappingComponent } from '../../mapping/mapping.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoundaryManagementService } from 'src/app/services/boundary-management.service';


@Component({
    selector: 'app-add-farm',
    templateUrl: './add-farm.component.html',
    styleUrls: ['./add-farm.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AddFarmComponent implements OnInit {

  countries: Countries[] = [];
  selectedCountry;
  provinceId;
  farmName;

  public validation_messages;

  farmForm = new FormGroup({
    farmName: new FormControl('', Validators.compose([
      Validators.required,
      Validators.maxLength(30),
      // Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$'),
      // Validators.pattern(".*\\S.*[a-zA-z0-9 ]"),
      Validators.pattern(/^((?!\s{2,}).)*$/)
    ])),
    country: new FormControl('', Validators.compose([
      Validators.required
    ])),
    province: new FormControl('', Validators.compose([
      Validators.required
    ]))
  });

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    public boundaryManagementService: BoundaryManagementService,
    public helper: HelperService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<MappingComponent>) {
    // if (data.countries != null) {
    //   this.countries = data.countries;
    // }

    this.boundaryManagementService.getCountries().subscribe((countries) => {
      this.countries = countries;
    })

    this.validation_messages = {
      'farmName': [
        { type: 'required', message: translate.instant('ADD-FARM-DIALOG.ERROR-NAME-REQUIRED') },
        { type: 'maxlength', message: translate.instant('ADD-FIELD-DIALOG.ERROR-NAME-LENGTH') },
        { type: 'pattern', message: translate.instant('ADD-FIELD-DIALOG.ERROR-PATTERN') }
      ],
      'country': [
        { type: 'required', message: translate.instant('ADD-FARM-DIALOG.ERROR-COUNTRY-REQUIRED') }
      ],
      'province': [
        { type: 'required', message: translate.instant('ADD-FARM-DIALOG.ERROR-PROVINCE-REQUIRED') }
      ]
    }
  }




  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
    });
  }

  addFarm() {
    this.farmForm.markAllAsTouched();
    if (this.farmForm.valid) {
      var userId = this.helper.getUserId();
      var tenantId = this.helper.getTenantId();
      let newFarm: AddFarm = {
        name: this.farmForm.get('farmName').value,
        provinceId: Number(this.farmForm.get('province').value),
        userCreated: userId,
        tenantId: tenantId
      }
      this.boundaryManagementService.insertFarm(newFarm).subscribe((result) => {
        this.dialogRef.close({option: "add",
          farmId: result.id,
          farmName: this.farmForm.get('farmName').value
        });
      });
    } else {
      this.openSnackBar(this.translate.instant("ADD-FARM-DIALOG.INFO-NEEDED"), this.translate.instant("SNACKBAR.DISMISS"));
    }
  }

  //   filterCountries(id) {
  //     return this.countries.filter(provinces => provinces.id === id);
  // }

}
